import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_calendar",
  "use": "svg_calendar-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"svg_calendar\"><path stroke=\"#fff\" d=\"M.5 3.5h14V14H.5z\" /><circle cx=\"4\" cy=\"7.1\" r=\".8\" fill=\"#fff\" /><circle cx=\"7.5\" cy=\"7.1\" r=\".8\" fill=\"#fff\" /><circle cx=\"7.5\" cy=\"10.4\" r=\".8\" fill=\"#fff\" /><circle cx=\"11\" cy=\"10.4\" r=\".8\" fill=\"#fff\" /><path stroke=\"#fff\" d=\"M3.5.5v3M11.3.5v3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol